import { X } from "lucide-react";

interface CulturalCautionPanelProps {
  title?: string;
  message: string;
  testId?: string;
  onDismiss?: () => void;
}

export function CulturalCautionPanel({
  title = "Respect note",
  message,
  testId = "cultural-caution-panel",
  onDismiss
}: CulturalCautionPanelProps) {
  return (
    <section className="cultural-note" data-testid={testId} aria-label="Cultural accuracy note">
      {onDismiss ? (
        <button
          type="button"
          className="dismiss-button"
          aria-label="Dismiss cultural accuracy note"
          onClick={onDismiss}
        >
          <X size={16} aria-hidden="true" />
        </button>
      ) : null}
      <h3>{title}</h3>
      <p data-testid="cultural-caution">{message}</p>
    </section>
  );
}
